import React from 'react';
import { dayShort, num } from './weeklyPlanUtils';

export const WeekProductGrid = ({ week }) => (
  <div className="border rounded-lg overflow-x-auto" data-testid="wp-product-grid">
    <table className="w-full text-sm">
      <thead>
        <tr className="bg-zinc-100 text-[11px] uppercase tracking-wide text-zinc-600">
          <th className="text-left px-3 py-2">Product</th>
          {week.days.map((d) => <th key={d.date} className="text-right px-2 py-2 whitespace-nowrap">{dayShort(d.date)}</th>)}
          <th className="text-right px-3 py-2">Week</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-zinc-100">
        {week.products.map((p) => (
          <tr key={p.product_name} className="hover:bg-zinc-50" data-testid={`wp-grid-row-${p.product_name}`}>
            <td className="px-3 py-1.5">{p.product_name}</td>
            {week.days.map((d) => (
              <td key={d.date} className="px-2 py-1.5 text-right font-mono">{p.by_day[d.date] ? num(p.by_day[d.date], 1) : ''}</td>
            ))}
            <td className="px-3 py-1.5 text-right font-mono font-semibold">{num(p.units, 1)}</td>
          </tr>
        ))}
        {week.products.length === 0 && (
          <tr><td colSpan={9} className="px-3 py-6 text-center text-muted-foreground">No orders this week.</td></tr>
        )}
        <tr className="bg-zinc-50 font-semibold">
          <td className="px-3 py-2">Day total</td>
          {week.days.map((d) => <td key={d.date} className="px-2 py-2 text-right font-mono">{d.units ? num(d.units, 1) : ''}</td>)}
          <td className="px-3 py-2 text-right font-mono text-[#005F73]" data-testid="wp-grid-week-total">{num(week.units, 1)}</td>
        </tr>
      </tbody>
    </table>
  </div>
);
